const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://rappapi.a-wm.ru';

class ApiService {
  async fetchProperties() {
    try {
      const response = await fetch(`${API_BASE_URL}/properties`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching properties:', error);
      throw error;
    }
  }

  async fetchProperty(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/properties/${id}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error(`Error fetching property ${id}:`, error);
      throw error;
    }
  }

  async identifyUser({ externalId, name, username }) {
    const form = new FormData();
    form.append('external_id', externalId);
    if (name) form.append('name', name);
    if (username) form.append('username', username);
    const res = await fetch(`${API_BASE_URL}/users/identify`, { method: 'POST', body: form });
    if (!res.ok) throw new Error('Failed to identify user');
    return res.json();
  }

  async logPropertyView({ propertyId, externalUserId }) {
    const form = new FormData();
    if (externalUserId) form.append('external_user_id', externalUserId);
    const res = await fetch(`${API_BASE_URL}/properties/${propertyId}/view`, { method: 'POST', body: form });
    if (!res.ok) throw new Error('Failed to log view');
    return res.json();
  }

  async logSearch({ query, city, type, minPrice, maxPrice, minRooms, externalUserId }) {
    const form = new FormData();
    if (query) form.append('query', query);
    if (city) form.append('city', city);
    if (type) form.append('type', type);
    if (minPrice != null && minPrice !== '') form.append('min_price', String(minPrice));
    if (maxPrice != null && maxPrice !== '') form.append('max_price', String(maxPrice));
    if (minRooms != null && minRooms !== '') form.append('min_rooms', String(minRooms));
    if (externalUserId) form.append('external_user_id', externalUserId);
    const res = await fetch(`${API_BASE_URL}/search/log`, { method: 'POST', body: form });
    if (!res.ok) throw new Error('Failed to log search');
    return res.json();
  }

  formatPrice(price, currency = 'RUB') {
    return new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
    }).format(price);
  }

  getPropertyTypeLabel(type) {
    const labels = {
      'apartment': 'Квартира',
      'villa': 'Вилла',
      'house': 'Дом',
      'studio': 'Студия'
    };
    return labels[type] || type;
  }
}

export default new ApiService();
